import { render } from "./VariableList.vue?vue&type=template&id=cc4f828a&ts=true"
import script from "./VariableList.vue?vue&type=script&lang=ts"
export * from "./VariableList.vue?vue&type=script&lang=ts"

import "./VariableList.vue?vue&type=style&index=0&id=cc4f828a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
